import {httpClient} from "./httpClient";
import {parameters} from "../parameters";
import * as utils from "./utils.js";
import {formatDate} from "@/dateHelper/dateHelper";

const operators = {
    ">": ".gt=",
    "<": ".lt=",
    "<=": ".lte=",
    ">=": ".gte=",
    "!=": ".notEquals=",
    "=": "="
};

const getAlias = async () => {
    return await httpClient.get(`${parameters.poslogApiUrl}/alias`)
        .then((response)=> {
            return response;
        })
        .catch((error)=> {
            // eslint-disable-next-line no-console
            console.log(error);
            throw error;
        });
};

const getHistory = async (transactionId) => {
    return await httpClient.get(`${parameters.poslogApiUrl}/poslogs/${transactionId}`
    ).then((response) => {
        return response.data
            .sort((a, b) => a.version - b.version)
            .map((val, index) => {
                return {...val, releaseNb: index + 1}
            });
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        throw error;
    });

}

const getXML = async (transactionId, messageDateTime, version, raw) => {
    const versionPart = (messageDateTime == null || version == null) ?
        "lastXML"
        : `${messageDateTime}/${version}`;

    return await httpClient.get(
        `${parameters.poslogApiUrl}/poslogs/${transactionId}/${versionPart}?raw=${raw}`
    ).then((response) => {
        return response.data;
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        throw error;
    });

};

const getPoslogByTransactionId = async (transactionId, raw) => {

    return await httpClient.get(`${parameters.poslogApiUrl}/poslogs?transactionId=${transactionId}&raw=${raw}`)
        .then((response)=> {
            return response.data.data[0];
        })
        .catch((error)=> {
            // eslint-disable-next-line no-console
            console.log(error);
            throw error;
        });
};

const getPoslogs = async (beginDate, endDate, searchQuery, filters, poslogsTableOptions) => {
    let searchParams = searchQuery ? [...searchQuery] : [];

    if (filters) {
        searchParams = searchParams.concat(
            filters.map(filterToSearchParam)
        );
    }

    if (beginDate) {
        const formatedDate = formatDate(beginDate).replace("+", "%2B");
        searchParams.push({
                label: 'transactionDateTime',
                operator: '>=',
                value: formatedDate
            }
        );
    }
    if (endDate) {
        const formatedDate = formatDate(endDate).replace("+", "%2B");
        searchParams.push({
                label: 'transactionDateTime',
                operator: '<=',
                value: formatedDate
            }
        );
    }

    const page = poslogsTableOptions.page - 1;
    searchParams.push({label: 'from', operator: '=', value: page * poslogsTableOptions.itemsPerPage});
    searchParams.push({label: 'size', operator: '=', value: poslogsTableOptions.itemsPerPage});

    if(poslogsTableOptions.sortBy.length > 0) {
        searchParams.push({label: 'sortBy', operator: '=', value: poslogsTableOptions.sortBy[0]});
        searchParams.push({label: 'sortOrder', operator: '=', value: poslogsTableOptions.sortDesc.slice(-1).pop() ? 'asc' : 'desc'});
    }

    const httpQueryParam = searchParams
        .map(param => {
            let apiOperator = operators[param.operator];
            return param.label + apiOperator + param.value;
        })
        .join("&");

    return await httpClient
        .get(`${parameters.poslogApiUrl}/poslogs?${httpQueryParam}`)
        .then(apiResponse => {
            const searchPosLogResponse = apiResponse.data.data;
            let posLogs = [];
            let nbMaxPoslogs = apiResponse.data.metadata.hits || 0;
            if(!searchPosLogResponse) return {posLogs,nbMaxPoslogs};
            searchPosLogResponse.forEach(function(posLogUnformatted) {
                posLogs.push({
                    createdAt: posLogUnformatted.metadata.createdAt,
                    country: posLogUnformatted.poslog.transaction.businessUnit.find(businessUnit => businessUnit.unitID.typeCode === "DKT:Country").unitID.name,
                    bu: posLogUnformatted.poslog.transaction.businessUnit.find(businessUnit => businessUnit.unitID.typeCode !== "DKT:Country").unitID.value,
                    workstationID: posLogUnformatted.poslog.transaction.workstationID.value,
                    sequenceNumber: posLogUnformatted.poslog.transaction.sequenceNumber,
                    transactionDateTime: posLogUnformatted.poslog.transaction.poslogDateTime.find(posLogEvent => posLogEvent.typeCode === "Transaction").value,
                    transactionID: posLogUnformatted.poslog.transaction.transactionID,
                    trailerText: utils.decodeTrailerText(posLogUnformatted.poslog.transaction.trailerText),
                    raw: posLogUnformatted
                })
            });
            return {posLogs,nbMaxPoslogs}
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.log(error);
            return {posLogs :[], nbMaxPoslogs: 0}
        });
};

let filterToSearchParam = (filter) => {
    const operator = filter.isExclude ? inverseOperator(filter.operator) : filter.operator;
    return {
        label: filter.label,
        operator,
        value: filter.value
    };
}

let inverseOperator = (operator) => {
    switch (operator) {
        case '=' : return '!=';
        case '!=' : return '=';
        case '<=' : return '>';
        case '>' : return '<=';
        case '>=' : return '<';
        case '<' : return '>=';
        case 'exists' : return 'notExists';
        case 'notExists' : return 'exists';
    }
};

export {
    getHistory,
    getPoslogs,
    getXML,
    getPoslogByTransactionId,
    getAlias
}
